/* omg-variant-media-filter — show only the selected colour's gallery media
   (front + back), hiding other colours. Media/thumbnails carry data-omg-mcolor
   (colour slug from filename). No-op unless 2+ distinct colours are present, so
   products whose images don't encode colour are unaffected. */
(function () {
  function slug(s) { return (s || '').trim().toLowerCase().replace(/\s+/g, '-'); }

  function selectedColor(scope) {
    // checked swatch/radio input for the Color option
    var inp = scope.querySelector(
      'input[data-option-name="Color" i]:checked, input[data-option-name="Colour" i]:checked'
    );
    if (inp) return slug(inp.value);
    // dropdown (swatch_dropdown / select) fallback
    var opt = scope.querySelector(
      'select [data-option-name="Color" i][selected], select [data-option-name="Colour" i][selected]'
    );
    if (opt) return slug(opt.value || opt.textContent);
    return null;
  }

  function apply(gallery, scope) {
    var items = gallery.querySelectorAll('[data-omg-mcolor]');
    if (!items.length) return;
    var colors = {};
    items.forEach(function (el) {
      var c = el.getAttribute('data-omg-mcolor');
      if (c) colors[c] = 1;
    });
    if (Object.keys(colors).length < 2) return; // nothing meaningful to filter
    var color = selectedColor(scope);
    if (!color) return;
    // Safety: only filter when the selected colour actually has matching media,
    // else we'd hide everything (empty gallery) for an undetected colour.
    var hasMatch = false;
    items.forEach(function (el) { if (el.getAttribute('data-omg-mcolor') === color) hasMatch = true; });
    if (!hasMatch) {
      items.forEach(function (el) { el.style.display = ''; }); // show all, no-op filter
      return;
    }
    items.forEach(function (el) {
      var c = el.getAttribute('data-omg-mcolor');
      // hide media that belongs to a *different* colour; keep matching + uncoloured
      el.style.display = (c && c !== color) ? 'none' : '';
    });
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      var scope = gallery.closest('.product, section') || document;
      var run = function () { apply(gallery, scope); };
      run();
      // re-filter when the Color option changes (let Dawn set active media first)
      scope.addEventListener('change', function (e) {
        var t = e.target;
        var name = t && t.getAttribute && t.getAttribute('data-option-name');
        if (name && /colou?r/i.test(name)) setTimeout(run, 60);
      });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
